import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { MatCard } from '@angular/material/card'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { ServiceTypeCreateComponent } from '../../../features/service/service-type-create/service-type-create.component'
import { ServiceTypeService } from '../../../core/services/service/service-type/service-type.service'
import { ServiceTypeEditComponent } from '../../../features/service/service-type-edit/service-type-edit.component'
import { FormSearchComponent } from '../../../shared/components/form-search/form-search.component'
import { ServiceOrderService } from '../../../core/services/service/service-order/service-order.service'
import { ServiceOrderCreate } from '../../../features/service/service-order/service-order-create/service-order-create.component'
import { ContractCreateComponent } from '../../../features/contract/contract-create/contract-create.component'
import { ResponseRequestModel } from '../../../core/models/response.model'
import { downloadBase64File } from '../../../shared/utils/download_base64'
import { convertCurrency } from '../../../shared/utils/utils'
import { ProposalClientCreateComponent } from '../../../features/proposal/proposal-client-create/proposal-client-create.component'
import { ProposalClientEditComponent } from '../../../features/proposal/proposal-client-edit/proposal-client-edit.component'
import { ProposalClientService } from '../../../core/services/proposal/proposal-client/proposal-client.service'
import { ContractClientService } from '../../../core/services/contract/contract-client/contract-client.service'
import { MatPaginator, PageEvent } from '@angular/material/paginator'
import { OccurrencesModalEditComponent } from '../../../features/occurrence/occurrences-modal-edit/occurrences-modal-edit.component'
import { AngularMaterialModule } from "../../../core/modules/angular-material/angular-material.module";
import { MatButtonModule } from '@angular/material/button'
import { OccurrencesModalCreateComponent } from '../../../features/occurrence/occurrences-modal-create/occurrences-modal-create.component'
import { OccurrenceService } from '../../../core/services/occurrence/occurrences/occurrences.service'
import { OccurrenceCreateComponent } from "../../../features/occurrence/occurrence-create/occurrence-create.component";
import { OccurrenceEditComponent } from '../../../features/occurrence/occurrence-edit/occurrence-edit.component'

@Component({
  selector: 'occurrences',
  imports: [
    MatCard,
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    MatPaginator,
    MatButtonModule,
    AngularMaterialModule,
    OccurrenceCreateComponent
  ],
  templateUrl: './occurrences.component.html',
  styleUrl: './occurrences.component.scss',
  providers: [ServiceOrderService, AuthService],
  standalone: true,
})
export class OccurrencesComponent implements OnInit {

  constructor(
    private proposalClientService: ProposalClientService,
    private contractClientService: ContractClientService,
    private occurrenceService: OccurrenceService,
    private authService: AuthService,
    private dialog: MatDialog,
  ) { }

  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  loading: boolean = false
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  inputSearch: string = ''
  data: any



  columns: any[] = [
    // { keyColumn: 'code', key: 'id', description: 'Código' },
    {
      keyColumn: 'description',
      key: 'descricao',
      description: 'Descrição',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: false },
      description: 'Ações',
    },
  ]
  screen: string = 'status cotação'

  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
  }

  checkColumnAction() {
    let index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        delete: this.checkPermission('deletar'),
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  search(event: any) {
    let search = event
    this.page = 1
    if (search) {
      this.searchForm.descricao = search
      // this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    if (this.searchForm.descricao) {
      // this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    // console.log('Retorno da API:', response);
    let list = []
    if (response.data) {
      for (let item of response.data) {
        // Verifica se o status da proposta é 'Pendente'


        list.push({
          ...item,
          valorTotalFormatado: `R$ ${convertCurrency(item.valorTotal)}`,
        })

        // if (item.statusPropostaDescricao === 'Pendente'){

        //   list.push({
        //     ...item,
        //     valorTotalFormatado: `R$ ${convertCurrency(item.valorTotal)}`,
        //   })
        // }
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
    this.loading = false
  }

  getListItems() {
    this.loading = true
    this.occurrenceService.listPagedOccurrence(this.page, this.rows).subscribe({
      next: (response: any) => {
        this.treatResponse(response)
      },
      error: (err: PagedContactTypeResponse) => { },
      complete: () => {
        this.loading = false
      },
    })

  }

  // searchListItems() {
  //   this.loading = true
  //   this.contractClientService
  //     .searchPagedContractClient(this.page, this.rows, this.searchForm)
  //     .subscribe({
  //       next: (response: any) => {
  //         this.treatResponse(response)
  //       },
  //       error: (err: PagedContactTypeResponse) => { },
  //       complete: () => {
  //         this.loading = false
  //       },
  //     })
  // }



  editItem(item: any) {
    const dialogRef = this.dialog.open(OccurrenceEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '500px',
      width: '500px',
      maxHeight: '250px',
      height: '250px',
      data: item,
    })
    dialogRef.componentInstance.responseCreate.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })

  }

  createItem() {
    const dialogRef = this.dialog.open(OccurrencesModalCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '850px',
      width: '850px',
      maxHeight: '550px',
      height: '550px',
      // panelClass: 'dialog-fullscreen',
    })
    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  // downloadItem(item: any) {
  //   this.contractClientService.downloadContractClient(item.id).subscribe({
  //     next: (response: any) => {
  //       console.log('res', response)
  //       downloadBase64File(
  //         response.data.fileContent,
  //         response.data.fileName,
  //         response.data.type,
  //       )
  //     },
  //     error: (err: ResponseRequestModel) => {
  //       console.error(err)
  //     },
  //     complete: () => { },
  //   })
  // }

  deleteItem(item: any) {
    console.log('item delete', item)
  }

}
